<div class="px-8 pt-4 h-full">
  <div class="stopka-linki flex items-center flex-grow py-4">
    <div class=" grid grid-cols-1 um-desktop:grid-cols-3 text-white flex-grow roboto">

      <div class="space-y-4" *ngFor="let strona of ($stronyCms | async)">
        <div *ngIf="!strona?.link; else linkObiekt" class="stopka-link um-stopka-linki">
          <a [routerLink]="['/strony/', strona.sciezkaUrl]">{{strona.nazwa}}</a>
        </div>
        <ng-template #linkObiekt>
          <div class="stopka-link um-stopka-linki">
            <a href="{{strona.link}}" target="_blank" matTooltip="{{'codes.generyczne.link-w-nowej-karcie' | translate}}">{{strona.nazwa}} </a>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="stopka-prawa-autorskie flex items-center">
    <div class="flex flex-wrap um-desktop:flex-nowrap justify-between w-full items-stretch">
      <div class="flex w-full um-desktop:w-auto items-center">
        <span class="material-icons mr-4">copyright</span>
        <span class="roboto">{{'codes.stopka.prezydent' | translate}}</span>
      </div>
    </div>
  </div>
</div>
